/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";
// import MiniCards from "./MiniCards";

/* Data Imports */

// import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  subHeading1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#000000",
    fontSize: "1rem",
    lineHeight: "1.688rem",
    margin: "0.55rem 0rem 0rem 0rem",
  },
    subHeading: {
    fontSize: "1rem",
    lineHeight: "1.688rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
}));

const HospitalVicinity = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.subHeading1}>
        <Typography className={classes.subHeading}>Motherhood</Typography>
        <Typography className={classes.subHeading}>1 KM</Typography>
      </div>
      <div className={classes.subHeading1}>
        <Typography className={classes.subHeading}>Manipal</Typography>
        <Typography className={classes.subHeading}>2.9 KM</Typography>
      </div>
      <div className={classes.subHeading1}>
        <Typography className={classes.subHeading}>Cloudnine</Typography>
        <Typography className={classes.subHeading}>3 KM</Typography>
      </div>
      <div className={classes.subHeading1}>
        <Typography className={classes.subHeading}>Sakra</Typography>
        <Typography className={classes.subHeading}>5.2 KM</Typography>
      </div>
    </React.Fragment>
  );
};

export default HospitalVicinity;
